import { Controller } from "@hotwired/stimulus"

export class InviteFeedbackController extends Controller {
    connect() {
        this.submitting = false
        this.closed = false
        this.onSubmit = () => { this.submitting = true }
        this.close = () => {
            if (this.submitting || this.closed) return
            this.closed = true
            const form = this.element.querySelector("form")
            const data = new URLSearchParams(new FormData(form))
            data.set("action", "skip")
            // Back/forward restoration can leave without making a new GET.
            // Finalize the response even when Turbo restores a cached page.
            // The Skip button's name="action" shadows form.action.
            fetch(form.getAttribute("action"), { method: "POST", body: data, keepalive: true, redirect: "manual" }).catch(() => {})
        }
        this.element.addEventListener("submit", this.onSubmit)
        document.addEventListener("turbo:before-visit", this.close)
        window.addEventListener("pagehide", this.close)
        window.addEventListener("popstate", this.close)
    }

    disconnect() {
        this.element.removeEventListener("submit", this.onSubmit)
        document.removeEventListener("turbo:before-visit", this.close)
        window.removeEventListener("pagehide", this.close)
        window.removeEventListener("popstate", this.close)
    }
}
